import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

// GET all tblWorkOrderPartses
export const getWorkOrderParts = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/work-order-parts`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching workOrderParts:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET a single tblWorkOrderParts
export const getWorkOrderPartsById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/work-order-parts/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching workOrderParts:",
      error.response?.data || error,
    );
    throw error;
  }
};

// GET all tblWorkOrderPartses by workOrderId
export const getWorkOrderPartsByWorkOrderId = async (workOrderId) => {
  const response = await axiosInstance.get(`${API_URL}/work-order-parts`, {
    params: { workOrderId },
  });
  return response.data;
};

// GET all tblWorkOrderPartses by many workOrderIds
export const getWorkOrderPartsByWorkOrderIds = async (workOrderIds = []) => {
  if (!workOrderIds.length) {
    return [];
  }

  const response = await axiosInstance.get(
    `${API_URL}/work-order-parts/by-work-order-ids`,
    {
      params: { workOrderIds: workOrderIds.join(",") },
    },
  );
  return response.data;
};

// CREATE a new tblWorkOrderParts
export const createWorkOrderParts = async (id, tblWorkOrderPartsData) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/work-order-parts/${id}`,
      tblWorkOrderPartsData,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error creating workOrderParts:",
      error.response?.data || error,
    );
    throw error;
  }
};

// UPDATE an existing tblWorkOrderParts
export const updateWorkOrderParts = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${API_URL}/work-order-parts/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating workOrderParts:",
      error.response?.data || error,
    );
    throw error;
  }
};

// DELETE a tblWorkOrderParts
export const deletetblWorkOrderParts = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${API_URL}/work-order-parts/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting workOrderParts:",
      error.response?.data || error,
    );
    throw error;
  }
};
